import React from 'react';
import { Loader } from 'components';
import { Button } from '@mui/material';

const ActionButton = ({ children, loading, buttonRef, disabled, ...rest }) => {
    return (
        <Button
            disableElevation
            disableRipple
            ref={buttonRef}
            disabled={loading || disabled}
            {...rest}
        >
            <Loader loading={loading} color="inherit" size={20} marginTop={0}>
                {children}
            </Loader>
        </Button>
    );
};

export default ActionButton;
